import store, { getStoreState } from 'config/store'
import { removeTriggerableCampaignImpression } from 'modules/impressions/actions'
import { ConversationId } from 'types/conversation'
import { WidgetImpressionSource } from 'types/targeting'

import { trackWidgetImpression } from './utils'

interface SendPlaybookImpressionArgs {
  playbookId: number,
  interactionId?: number,
  conversationId?: ConversationId,
  isVirtual?: boolean,
  isDelayed?: boolean,
  isExperiment?: boolean,
  playbookVersion?: number
}

export const sendPlaybookImpression = ({
  playbookId, interactionId, conversationId, isVirtual = false, isDelayed = false, isExperiment, playbookVersion
}: SendPlaybookImpressionArgs): void => {
  const { active = [], passive = [] } = getStoreState().impressions

  const isActiveImpression = active.includes(playbookId)
  const isPassiveImpression = passive.includes(playbookId)

  if (isActiveImpression || isPassiveImpression) {
    const sent = trackWidgetImpression(
      isActiveImpression ? WidgetImpressionSource.ACTIVE_PLAYBOOK : WidgetImpressionSource.PASSIVE_PLAYBOOK,
      { playbookId, interactionId, conversationId, virtual: isVirtual, isDelayed: isDelayed, isExperiment, playbookVersion }
    )

    if (sent) {
      store.dispatch(removeTriggerableCampaignImpression({
        source: isActiveImpression ? 'active' : 'passive',
        playbookId
      }))
    }
  }
}
